import { Component, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroupDirective,
  NgForm,
  Validators,
  FormGroup,
  FormBuilder
} from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { Router, ActivatedRoute } from '@angular/router';
import {AuthLayoutComponent} from '../layouts/auth/auth-layout.component';
import { EmailAuthProvider, getAuth, reauthenticateWithCredential, updatePassword } from "firebase/auth";
import { GeneralService } from '../services/general.service';
import Swal from 'sweetalert2';



export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const invalidCtrl = !!(control && control.invalid && control.parent.dirty);
    const invalidParent = !!(control && control.parent && control.parent.invalid && control.parent.dirty);

    return (invalidCtrl || invalidParent);
  }
}

@Component({
  selector: 'app-restpassword',
  templateUrl: './restpassword.component.html',
  styleUrls: ['./restpassword.component.css']
})
export class RestPasswordComponent implements OnInit {
  myForm: FormGroup;
  matcher = new MyErrorStateMatcher();
  token: string;
  currentuser: any;
  
 // tslint:disable-next-line:max-line-length
 constructor(public router: Router, private route: ActivatedRoute, private formBuilder: FormBuilder, private auth: AuthLayoutComponent,public GeneralService: GeneralService) {

  this.myForm = this.formBuilder.group({
    password: ['', [Validators.required, Validators.pattern('^(?=.*[0-9]+.*)(?=.*[a-zA-Z]+.*)[0-9a-zA-Z]{6,}$')]],
    confirmPassword: ['', [Validators.required]]
  }, { validator: this.checkPasswords });

  this.route.paramMap.subscribe(params => {
    this.token = params.get('token')
  })
  }


  checkPasswords(group: FormGroup) { // here we have the 'passwords' group
    const pass = group.controls.password.value;
    const confirmPass = group.controls.confirmPassword.value;

    return pass === confirmPass ? null : { notSame: true }
  }

  ngOnInit() {
  }

  
  
async ChangePassword() {
  const auth = getAuth();
  const user = auth.currentUser;
  console.log(user);
  this.currentuser = JSON.parse(localStorage.getItem("currentuser"));

  if (user) {
      try {
          // Attempt to update the password
          await updatePassword(user, this.myForm.get('password').value);
          console.log("Password updated successfully.");

          // Update the passwordChanged flag in Firestore
          await this.GeneralService.UpdateUserPasswordChangedByEmail(this.currentuser.email);

          // Navigate based on the user's role
          if (this.currentuser.role == "cluster" || this.currentuser.role == "ceo") {
              this.router.navigateByUrl("/dashboard");
          } else if (this.currentuser.role == "assign") {
              this.router.navigateByUrl("/assignuserdashboard");
          } else if (this.currentuser.role == "gm") {
              this.router.navigateByUrl("/dashboard-gm");
          } else if (this.currentuser.role == "auditer") {
              this.router.navigateByUrl("/dashboard-auditer");
          } else {
              this.router.navigate(["/admindashboard"]);
          }

      } catch (error) {
          // Handle the re-authentication error
          if (error.code === 'auth/requires-recent-login') {
              console.error("Session expired, re-authentication required.");

              // Prompt the user to enter their current password
              // const currentPassword = prompt("Session expired !, Please enter your Current Password to re-authenticate:");
              const { value: currentPassword } = await Swal.fire({
                title: 'Session Expired!',
                text: 'Please enter your current password to re-authenticate:',
                input: 'password',
                inputLabel: 'Current Password',
                inputPlaceholder: 'Enter your current password',
                showCancelButton: true,
                confirmButtonText: 'Submit',
                cancelButtonText: 'Cancel',
                inputValidator: (value) => {
                  if (!value) {
                    return 'You need to enter your current password!';
                  }
                }
              });
              if (currentPassword) {
                  try {
                      // Re-authenticate the user with the current password
                      const credential = EmailAuthProvider.credential(this.currentuser.email, currentPassword);
                      await reauthenticateWithCredential(user, credential);

                      // Retry the password update after successful re-authentication
                      await updatePassword(user, this.myForm.get('password').value);
                      console.log("Password updated successfully after re-authentication.");

                      // Update Firestore
                      await this.GeneralService.UpdateUserPasswordChangedByEmail(this.currentuser.email);

                      // Navigate based on the user's role
                      if (this.currentuser.role == "cluster" || this.currentuser.role == "ceo") {
                          this.router.navigateByUrl("/dashboard");
                      } else if (this.currentuser.role == "assign") {
                          this.router.navigateByUrl("/assignuserdashboard");
                      } else if (this.currentuser.role == "gm") {
                          this.router.navigateByUrl("/dashboard-gm");
                      } else if (this.currentuser.role == "auditer") {
                          this.router.navigateByUrl("/dashboard-auditer");
                      } else {
                          this.router.navigate(["/admindashboard"]);
                      }

                  } catch (reauthError) {
                      console.error("Re-authentication failed:", reauthError);
                      // Handle re-authentication failure (e.g., show an error message)
                  }
              } else {
                  console.log("Re-authentication was canceled by the user.");
              }
          } else {
              console.error("Error updating password:", error);
              // Handle other potential errors
          }
      }
  } else {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: 'No user is signed in.',
    });
  }
}

}
